(function() {
	'use strict';

	angular
		.module('appback')
		.controller('FilesfacturasController', FilesfacturasController)

	FilesfacturasController.$inject = ["Upload", "$timeout"];

	function FilesfacturasController(Upload, $timeout) {
		var vm = this;
		vm.fieldName = "";
		vm.value = { ficheros: [] };

		vm.url = "/backend/shipping/subirfactura";
		vm.agencia = "";
		vm.init = function() {

		}
		vm.uploadFiles = function(files) {
//			console.log(files, vm.agencia)
			if (files && files.length) {
				for (var i = 0; i < files.length; i++) {
					Upload.upload({
						url: vm.url,
						data: { file: files[i], provider: vm.agencia }
					}).then(function(resp) {
						$timeout(() => {
							location.reload();
						}, 2000);

					}, function(resp) {

					}, function(evt) {

					});
				}

			}
		}
	}

})();
